import { useState, useCallback } from "react";
import { db } from "../services/firebase";
import { ref, set, push } from "firebase/database";

export default function useCreateDomain() {
    const [creatingDomain, setCreating] = useState(false);
    const [creatingDomainError, setError] = useState(null);

    /**
     * Creates or updates a domain.
     * @param {string} name - Domain name
     * @param {string | null} domainId - If provided, updates existing domain
     * @param {number | null} orderId - Optional manual orderId value
     */
    const createDomain = useCallback(async (name, domainId = null, orderId = null) => {
        if (!name || !name.trim()) {
            setError("Please enter a valid domain name");
            return false;
        }

        try {
            setCreating(true);
            setError(null);

            // ✅ Step 1: Prepare reference
            let domainRef;
            if (domainId) {
                // Update existing domain
                domainRef = ref(db, `Domains/${domainId}`);
            } else {
                // Create new domain
                domainRef = push(ref(db, "Domains"));
                domainId = domainRef.key; // auto-generated Firebase ID
            }

            // ✅ Step 2: Prepare data
            const domainData = {
                name: name.trim(),
                domainId,
                orderId: orderId ?? Date.now(), // if not provided, use timestamp as fallback
                createdAt: Date.now(),
            };

            // ✅ Step 3: Write to Firebase
            await set(domainRef, domainData);

            console.log("✅ Domain created/updated:", domainData);
            return true;

        } catch (err) {
            console.error("❌ Error creating/updating domain:", err);
            setError("Failed to create or update domain");
            return false;

        } finally {
            setCreating(false);
        }
    }, []);

    return { createDomain, creatingDomain, creatingDomainError };
}
